import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../assets/amora_logo.png';

const Navbar = ({ user, setUser, setActiveRole }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('activeRole');
    sessionStorage.removeItem('amoraBetaDismissed');
    setUser(null);
    setActiveRole(null);
    navigate('/');
  };

  return (
    <nav className="bg-white border-b border-black py-4 px-6 flex justify-between items-center sticky top-0 z-50 font-mono text-black">
      {/* Logo & Clickable Title */}
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={() => navigate('/')}
      >
        <img src={logo} alt="Amora logo" className="h-10 w-10 border border-black" />
        <span className="text-xl font-bold uppercase tracking-wide">
         
        </span>
      </div>

      {/* Navigation & Actions */}
      <div className="flex items-center gap-4 text-sm font-semibold uppercase">
        {/* LanguageSelector can be re-enabled later if needed */}
        {/* <LanguageSelector /> */}

        {!user ? (
          <>
            <Link to="/about" className="hover:underline">
              {t('navbar.about')}
            </Link>
            <Link
              to="/login"
              className="border border-black px-4 py-1 hover:bg-black hover:text-white transition"
            >
              {t('navbar.login')}
            </Link>
          </>
        ) : (
          <>
            <span className="italic text-gray-600 lowercase">
              👤 {user.name || user.email}
            </span>
            <button
              onClick={handleLogout}
              className="border border-black px-4 py-1 hover:bg-black hover:text-white transition"
            >
              {t('navbar.logout')}
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
